<template>
     <div class="Report" :show="loading" :supplierId="supplierId">
         <div class="ReportHeader">
         <div :class="Cols">
             <div class="row">
                 <div class="col-4" style="padding-left: 0px;" >
                     <div class="form-group">
                         <label class="form-label">{{ $t('lbl_EMPBE_Report_Title_Type') }}</label>
                         <selection :value="ReportTypeVals" class="w-100 ReportSelectType" v-model="ReportTypeVals"  
                          :options="ReportType"
                          :clearable="false" :multiple="false"
                          :preselect-first="true">
                         </selection>
                       </div>
                 </div>
                 <div class="col-4">
                     <div class="form-group">
                         <label class="form-label">{{ $t('lbl_EMPBE_Report_Title_Year') }}</label>
                         <selection :value="FilterByYearsVals" class="w-100 ReportSelectType" v-model="FilterByYearsVals" 
                          :clearable="false" :multiple="false"
                          :preselect-first="true"
                          :options="FilterByYears">
                         </selection>
                       </div>
                 </div>
                 <div class="col-4">
                     <div class="form-group">
                         <label class="form-label">{{ $t('lbl_EMPBE_Report_Title_Desc') }}</label>
                         <selection :value="SortByDateVals" class="w-100 ReportSelectType" v-model="SortByDateVals" 
                          :clearable="false" :multiple="false"
                          :preselect-first="true"
                             :options="SortByDate">
                         </selection>
                       </div>
                 </div>
             </div>
         </div>
     </div>
     <div class='no-record'v-if="ReportData.length == 0"> {{$t('lbl_EMPBE_grid_noRecords')}}</div>
     <div class="ReportBody d-flex flex-wrap" v-if="ReportData.length > 0">
         <b-card v-for="item in ReportData" no-body class="b-r-3 dashboardCard ReportBodyCard" style="border-radius: 8px !important;">
            <a t_label="emp_backlist_Report" :href="item.type != 1 ? item.urlLink : `${Hrefs}/${item.companyId}/${item.batchId}`" target="_blank">
             <div class="dashboardCardHeader">
                 <img v-if="item.type!=1" :src= "item.imgPath" alt="Profile" class="ReportContent"/>
                 <img v-if="item.type==1" src="http://cdn-adsalecdn.oss-cn-shenzhen.aliyuncs.com/EMP/2-0/images/Report_1.jpg?x-oss-process=image/resize,h_200/format,webp" alt="Profile" class="ReportContent"/>
             </div>
             <div class="dashboardCardBody">
          
                 <div class="dashboardCardBody_Items">
                     <div class="dashboardCardBody_Title" v-html="item.title">
                     </div>
                     <div class="dashboardCardBody_Items_Left">
                        <span :class="[item.type==1 ? 'dashboardCardBody_Items_Left_span':(item.type==2 ? 'dashboardCardBody_Items_Left2_span':'dashboardCardBody_Items_Left3_span'), 'mt-auto']" >
                            {{$t('lbl_EMPBE_Report_Title_'+item.typeName)}}
                        </span>
                     </div>
                     <div class="dashboardCardBody_Items_Right">
                         {{ formatReportPeriod(item.months, item.years) }}
                     </div>
                 </div>
             </div>
         </a>
         </b-card>
     </div>  
     </div>
     

</template>
<script>
import { reportService } from '@/_services/report.service';  
export default {
    data() {
        return {
            Cols:"col-6",
            Hrefs:"",
            loading:false,
            ReportTypeVals:"0",
            FilterByYearsVals:"0",
            SortByDateVals:"0",
            ReportType:[{id:"0",label:this.$t("lbl_EMPBE_Report_Title_Option1")},{id:"1",label:this.$t("lbl_EMPBE_Report_Title_PerformanceReport")},{id:"2",label:this.$t("lbl_EMPBE_Report_Title_SourcingTrendsReport")},{id:"3",label:this.$t("lbl_EMPBE_Report_Title_MarketAnalysisReport")}],
            FilterByYears:[{id:"0",label:this.$t("lbl_EMPBE_Report_Title_Option1")},{id:"2024",label:"2024"},{id:"2023",label:"2023"}],
            SortByDate:[{id:"0",label:this.$t("lbl_EMPBE_Report_Title_Option2")},{id:"1",label:this.$t("lbl_EMPBE_Report_Title_Option3")}],
            ReportData:[],
        } ;
    },
    props: ['supplierId','IsStrus'],
    watch: {
        ReportTypeVals(){
            console.log("this.ReportTypeVals",this.ReportTypeVals)
            this.getBackList();

        },
        FilterByYearsVals(){

            this.getBackList();

        },
        SortByDateVals(){
            this.getBackList();


        },
        supplierId:{
            handler(){
                this.ReportData=[];
                this.getBackList();
                this.Cols="col-10"
            }
        }
    },
    created() {
        this.getBackList();
        
    },
    computed: {
        IsAdminUrl()
        {
            return this.IsStrus==0 ? '?IsAdminShow=true' :'';

        },
        user() {
            return this.$store.state.authentication.user
        },
    },
    mounted() {
    
    },
    methods: {
        resolveReportMonthKey(months) {
            const REPORT_MONTH_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            if (months == null || months === '') return '';
            const raw = String(months).trim();
            const lower = raw.toLowerCase();
            const abbr = REPORT_MONTH_ABBR.find(m => lower === m.toLowerCase() || lower.startsWith(m.toLowerCase()));
            if (abbr) return abbr;
            const numMatch = raw.match(/^(\d{1,2})/);
            if (numMatch) {
                const n = parseInt(numMatch[1], 10);
                if (n >= 1 && n <= 12) return REPORT_MONTH_ABBR[n - 1];
            }
            return '';
        },
        formatReportPeriod(months, years) {
            const keySuffix = this.resolveReportMonthKey(months);
            if (!keySuffix) return years ? String(years) : '';
            const monthLabel = this.$t('lbl_EMPBE_Report_Title_YearsOption_' + keySuffix);
            return years ? `${monthLabel}\u00A0${years}` : monthLabel;
        },
        getBackList(){
            var that = this;
            this.loading = true;
            var queryCompanyId = this.supplierId ? this.supplierId : that.user.empCompanyId;
            var query  = {
                CompanyId: queryCompanyId,
                Type: that.ReportTypeVals,
                Year: that.FilterByYearsVals,
                IsDescending: that.SortByDateVals,
                LangId : localStorage.currentLangId,
                IsStrus:that.IsStrus
            }
            var langs="";
            if(query.LangId==936)
            {
                langs="simp";
            }else if(query.LangId==950)
            {
                langs="trad";
            }else
            {
                langs="eng";
            }
            let url = (!process.env.VUE_APP_EMP_VIEW.includes("localhost") ? `${process.env.VUE_APP_EMP_VIEW}report/${langs}` : `https://www.chinaplasonline.com/eMarketplaceuat/report/${langs}`);
            console.log("内容",url)
            that.Hrefs= url
            reportService.GetReportsListByBack(query).then( res=>{
                that.ReportData = res.data;
            }).finally( _ => {
                that.loading = false;
            })
        }
    },
};
</script>

<style scoped>
::v-deep( .vue-treeselect__control) 
{
 border-radius: 10px !important;
}
.no-record{
    font-size: 3rem;
    font-weight: bold;
}
.dashboardCardBody_Title{
    min-height: 4.5vh;
}
.dashboardCard:hover {  
cursor: pointer;  
}  
.dashboardCard:hover .dashboardCardBody_Title{  
    color: #7968FF;
}  
.dashboardCard:hover .ReportContent
{  
    transform: scale(1.1); /* 图片放大10% */  
    
    border-top-left-radius: 8px !important;
    border-top-Right-radius: 8px !important;
}  
.Report {
 margin: 30px;
}
.ReportBodyCard
{
 float: left;
 margin-right: 2%;
}
.ReportHeader .form-label
{
 font-size: 14px;
 font-weight: 700;
}
.ReportSelectType
{

}
.dashboardCard
{
 width: 325px;
}
.dashboardCardHeader
{
 width: 325px;
 height: 202.623px;
 overflow: hidden; 
 border-top-left-radius: 8px !important;
 border-top-Right-radius: 8px !important;
 
}
.dashboardCardHeader img
{
 width: 100%;
 height: 100%;
 border-top-left-radius: 8px !important;
 border-top-Right-radius: 8px !important;
}
.dashboardCardBody
{
 padding: 16px;
 height: auto;
}
.dashboardCardBody_Items
{
 position: relative;
}
.dashboardCardBody_Title
{
 font-size: 14px;
 font-weight: 700;
 color: #2b2b2b;
 display: -webkit-box;  
 -webkit-line-clamp: 2;  
 -webkit-box-orient: vertical;  
 overflow: hidden;  
 /* 确保文本超出时显示省略号 */  
 text-overflow: ellipsis;  
}
.ReportContent
{
    width: 325px;
    height: auto;
    transition: transform 0.5s ease; /* 平滑过渡效果 */ 
}
.dashboardCardBody_Items_Left
{
 color: #FFF;
 font-size: 12px;
 font-weight: 700;
 margin-top: 5px;
}
.dashboardCardBody_Items_Left_span
{
 border-radius: 3px;
 background: #7128E8;
 padding: 2px 8px;

}
.dashboardCardBody_Items_Left2_span
{
    border-radius: 3px;
    background: #E28128;
    padding: 2px 8px;
}
.dashboardCardBody_Items_Left3_span
{
 border-radius: 3px;
 background: #C32A31;
 padding: 2px 8px;
}
.dashboardCardBody_Items_Right
{
 font-size: 12px;
 font-weight: 400;
 color: var(--on-surface-50, rgba(0, 0, 0, 0.50));
 margin-top: 5px;
 position: absolute;
 bottom: 3px;
 right: 5px;
}
</style>